export function fnEnableConsole() {
  if (!window.console || !window.__console) return;
  for (const key in window.__console) {
    if (typeof window.__console[key] === 'function') {
      window.console[key] = window.__console[key];
    }
  }
}
export function fnDisableConsole() {
  if (!window.console) return;
  window['__console'] = {};
  for (const key in window.console) {
    window.__console[key] = window.console[key];
    if (typeof window.console[key] === 'function') {
      window.console[key] = function() {};
    }
  }
}
